import React from "react";
import PortfolioList from "../../components/projectComponents/portfolioList/PortfolioList";
import PortfolioHero from "../../components/projectComponents/portfolioHero/PortfolioHero";

const Projects = () => {
  return (
    <div>
      <PortfolioHero />
      <PortfolioList />
    </div>
  );
};

export default Projects;
